import { useEffect, useRef } from "react";
import { Nullable } from "shared/lib/typeCheck.lib";

type Debounce = {
  time: number;
  timer: ReturnType<typeof window.setTimeout> | null;
};

type DebounceFunc = (callback: Nullable<() => void>) => void;

type UseDebounceReturnType = {
  debounce: DebounceFunc;
  resetDebounce: VoidFunction;
  active: boolean;
};

export const useDebounce = (delay = 600): UseDebounceReturnType => {
  const debounce = useRef<Debounce>({
    time: delay,
    timer: null,
  });
  debounce.current.time = delay;

  const resetDebounce = () => {
    debounce.current.timer && clearTimeout(debounce.current.timer);
    debounce.current.timer = null;
  };

  const setDebounce: DebounceFunc = (callback) => {
    resetDebounce();

    debounce.current.timer = setTimeout(() => {
      debounce.current.timer = null;
      callback?.();
    }, debounce.current.time);
  };

  useEffect(
    () => () => {
      resetDebounce();
    },
    []
  );

  return {
    debounce: setDebounce,
    resetDebounce,
    active: !!debounce.current.timer,
  };
};
